export default __webpack_public_path__ + "static/media/flashcards-icon.9e60a0ed.png";